import type { GridFilterModel, GridPaginationModel } from '@mui/x-data-grid'
import axios from 'axios'

import { getCountryAsAlpha2Code } from '@/constants/country'
import { PORTFOLIO_MANAGER_API_URL } from '@/features/bidding/endpoints/bids'
import type { BidOverviewSummaryPage } from '@/features/bidding/types/bidOverviewSummary'
import { toInternalBidOverviewSummaryGroup } from '@/features/bidding/utils/model/modelConversion'
import type { BidOverviewSummary } from '@/openapi/v1/msa-portfolio-manager'
import { getFilterItemValue } from '@/utils/datagrid/filters'

export type BidOverviewSummaryPageQueryParams = {
  country: CountryIdentifier
  filter: GridFilterModel
  pagination: GridPaginationModel
}

export const getBidOverviewSummary = async (
  params: BidOverviewSummaryPageQueryParams,
): Promise<BidOverviewSummaryPage> => {
  const response = await axios.get<BidOverviewSummary>(`${PORTFOLIO_MANAGER_API_URL}/bid/overview-summary`, {
    params: buildBidOverviewSummaryParams(params),
  })
  return {
    groupedBids: (response.data.groupedBids ?? []).map((group) => toInternalBidOverviewSummaryGroup(group)),
    totalCount: response.data.totalCount ?? 0,
  }
}

const buildBidOverviewSummaryParams = (params: BidOverviewSummaryPageQueryParams) => {
  const urlParams = new URLSearchParams()

  urlParams.append('page', String(params.pagination.page))
  urlParams.append('pageSize', String(params.pagination.pageSize))
  urlParams.append('countryCode', getCountryAsAlpha2Code(params.country))

  const portfolios = getFilterItemValue<string[]>(params.filter, 'portfolio')
  const marketPrograms = getFilterItemValue<string[]>(params.filter, 'marketProgram')
  const deliveryDay = getFilterItemValue<string>(params.filter, 'deliveryDay')

  if ((portfolios?.length ?? 0) > 0) urlParams.append('portfolioCodes', portfolios!.join(','))
  if ((marketPrograms?.length ?? 0) > 0) urlParams.append('marketPrograms', marketPrograms!.join(','))
  if (deliveryDay) urlParams.append('deliveryDay', deliveryDay)

  return urlParams
}
